/**
 * Zoho OAuth Callback Page
 * 
 * This page is loaded in the popup after Zoho redirects back.
 * It extracts the authorization code from the URL and sends it
 * back to the parent window via postMessage.
 * 
 * Route: /zoho-callback
 * Must be registered in Zoho API Console as the Authorized Redirect URI.
 */
const ZohoCallback = () => {
  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const error = url.searchParams.get('error');
    const state = url.searchParams.get('state');
    const errorDescription = url.searchParams.get('error_description');

    // Send the result back to the parent window
    if (window.opener) {
      if (code) {
        window.opener.postMessage(
          {
            type: 'zoho-auth-success',
            code,
            state,
          },
          window.location.origin
        );
      } else if (error) {
        window.opener.postMessage(
          {
            type: 'zoho-auth-error',
            error: errorDescription || error,
            state,
          },
          window.location.origin
        );
      }
    }

    // Auto-close after a short delay (in case user has popups blocked)
    const timer = setTimeout(() => {
      window.close();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'Arial, sans-serif',
        background: '#f8fafc',
        padding: '24px',
      }}
    >
      <div
        style={{
          background: '#fff',
          padding: '32px 48px',
          borderRadius: '12px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔗</div>
        <h2 style={{ color: '#0f172a', margin: '0 0 8px' }}>Connecting to Zoho Books...</h2>
        <p style={{ color: '#64748b', margin: '0' }}>
          You can close this window once the connection is complete.
        </p>
      </div>
    </div>
  );
};

export default ZohoCallback;